import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { UpgradeModule } from '@angular/upgrade/static';
import { HttpModule } from '@angular/http';
import * as angular from 'angular';

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import 'rxjs/add/operator/toPromise';
import { forkJoin } from 'rxjs/observable/forkJoin';

import { WrapperService } from './api/wrapper.service';
import { EmployeesEditHistoryCacheService } from './core/employee-edit-history-cache.service';

export function initializeApp1(upgrade: UpgradeModule, wrapperService: WrapperService, employeesEditHistoryCacheService: EmployeesEditHistoryCacheService): Function {
	return (): Promise<any> => {
		console.log('app init');
		return new Promise((resolve: any, reject: any): void => {
			forkJoin(
				employeesEditHistoryCacheService.updateData(),
				wrapperService.wrapGetRequest('/settings/user/current', 'initUser'),
			)
				.subscribe((res: any[]) => {
					const response: any = res[1];

					if (!response.success) {
						alert('Technical error. User details is not loaded. Reload the app and try again.');
					}
					console.log('user inited');
					angular.module('userInfo', []).constant('userInfo', response.user);
					upgrade.bootstrap(document.documentElement, ['timetracker2'], { strictDi: true });
					resolve(true);
				}, (err: any) => {
					reject(err);
				});

		});
	};
}

@NgModule({
	declarations: [
		AppComponent
	],
	bootstrap: [
		AppComponent
	],
	imports: [
		BrowserModule,
		HttpModule,
		CoreModule,
		BrowserAnimationsModule
		// LogService
	],
	providers: [
		{ provide: APP_INITIALIZER, useFactory: initializeApp1, deps: [UpgradeModule, WrapperService, EmployeesEditHistoryCacheService], multi: true }
	]
})

export class AppModule {
	constructor(upgrade: UpgradeModule,
		wrapperService: WrapperService
	) {
		// 	wrapperService.wrapGetRequest('https://tt.rqp.co/settings/user/current', 'initUser')
		// 		.subscribe((user: Employee) => {
		// 			console.log('user inited');
		// 			angular.module('userInfo', []).constant('userInfo', user);
		// 			upgrade.bootstrap(document.documentElement, ['timetracker2'], {strictDi: true});
		// 		});
	}
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts